const COGNITO_CLIENT_ID = import.meta.env.APP_COGNITO_CLIENT_ID;
const COGNITO_DOMAIN = import.meta.env.APP_COGNITO_DOMAIN;
const REDIRECT_URI = import.meta.env.APP_REDIRECT_URI;
const AUTH_URL = `https://${COGNITO_DOMAIN}/signup?client_id=${COGNITO_CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}` || '';
const REGION = import.meta.env.APP_REGION || '';
const USER_POOL_ID = import.meta.env.APP_USER_POOL_ID || '';
const USER_POOL_WEB_CLIENT_ID = import.meta.env.APP_USER_POOL_WEB_CLIENT_ID || '';
const MANDATORY_SIGN_IN = import.meta.env.APP_MANDATORY_SIGN_IN === 'true' || false;
const AUTHENTICATION_FLOW_TYPE = import.meta.env.APP_AUTHENTICATION_FLOW_TYPE || 'USER_SRP_AUTH';
const OAUTH = {
  domain: import.meta.env.APP_OAUTH_DOMAIN || '',
  scope: import.meta.env.APP_OAUTH_SCOPE?.split(',') || [],
  redirectSignIn: import.meta.env.APP_OAUTH_REDIRECT_SIGNIN || '',
  redirectSignOut: import.meta.env.APP_OAUTH_REDIRECT_SIGNOUT || '',
  responseType: import.meta.env.APP_OAUTH_RESPONSE_TYPE || 'code',
};

const CLIENT_NAME = import.meta.env.APP_CLIENT_NAME;
const GOOGLE_ANALYTICS_ID = import.meta.env.APP_GOOGLE_ANALYTICS_ID || '';
const BACKGROUND_COLOR = `#${import.meta.env.APP_BACKGROUND_COLOR}`;
const APP_RELEASE_VERSION = import.meta.env.APP_RELEASE_VERSION;

export {
  AUTH_URL,
  REGION,
  USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID,
  MANDATORY_SIGN_IN,
  AUTHENTICATION_FLOW_TYPE,
  OAUTH,
  CLIENT_NAME,
  GOOGLE_ANALYTICS_ID,
  BACKGROUND_COLOR,
  APP_RELEASE_VERSION,
};
